import Icon from '@components/atoms/icon/icon';
import Link from '@components/atoms/link/link';
import React from 'react';
import useAnalyticEvents from '@hooks/analytics/use-analytic-events';
import { getDSALink } from '@helpers/utils/products';
import { Product } from '@interfaces/models/product';
import { User } from '@interfaces/models/user';
import { useTranslation } from 'next-i18next';

import styles from './product-report.module.scss';

type ProductReportProps = {
  productId: Product['id'];
  email: User['email'];
  local: User['language']['code'];
};
const ProductReport: React.FC<ProductReportProps> = ({ productId, email, local }): React.JSX.Element => {
  const { t } = useTranslation();
  const { sendAnalyticEvent } = useAnalyticEvents('product');

  const dsaLink = getDSALink(productId, email, local);

  const trackDSAClick = () => {
    sendAnalyticEvent('report_item', {
      product_id: productId
    });
  };

  return (
    <section className={styles.productReport}>
      <Link
        className={styles.productReport__link}
        href={dsaLink}
        onClick={trackDSAClick}
        target={'_self'}
        itemProp="url"
        data-cy="product-description-dsa-button"
      >
        <Icon
          className={styles.productReport__icon}
          name={'flag-default'}
        />
        <span className={styles.productReport__text}>{t('PRODUCT.DESCRIPTION.DSA_BTN')}</span>
      </Link>
    </section>
  );
};

export default ProductReport;
